import React from 'react';
import MainCarousel from './paginasInicio/MainCarousel';
import HeroPage from './paginasInicio/HeroPage';
import Experiencia from './paginasInicio/Experiencia';
import Gastronomia from './paginasInicio/Gastronomia';
import Cashless from './paginasInicio/Cashless';
import Ubicacion from './paginasInicio/Ubicacion';
import Redes from './paginasInicio/Redes';
import ShowsEventos from './paginasInicio/ShowsEventos';

const Inicio = () => {
    return (
        <div className='divoverflow' id="inicio">
            <MainCarousel/>
            
            <Experiencia theme="ltm"/>

            <Gastronomia theme="ltm"/>
            
            <Cashless theme="ltm"/>

            <Ubicacion theme="ltm"/>

            <Redes theme="ltm"/>

            <ShowsEventos theme="ltm"/>

        </div>
    );
}

export default Inicio;